import { render, staticRenderFns } from "./WebixUIComponent.vue?vue&type=template&id=9735831e&scoped=true&"
import script from "./WebixUIComponent.vue?vue&type=script&lang=js&"
export * from "./WebixUIComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9735831e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9735831e')) {
      api.createRecord('9735831e', component.options)
    } else {
      api.reload('9735831e', component.options)
    }
    module.hot.accept("./WebixUIComponent.vue?vue&type=template&id=9735831e&scoped=true&", function () {
      api.rerender('9735831e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/common/WebixUIComponent.vue"
export default component.exports